/* DASKIとは：リード本文の VIEW MORE（SPのみ展開） */
(function () {
  function initMore(root) {
    (root || document).querySelectorAll('[data-about-more]').forEach(function (wrap) {
      if (wrap.dataset.aboutMoreBound) return;
      var btn = wrap.querySelector('.daski-alead__more');
      if (!btn) return;
      wrap.dataset.aboutMoreBound = '1';
      btn.addEventListener('click', function () {
        wrap.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      });
    });
  }

  if (document.readyState !== 'loading') {
    initMore();
  } else {
    document.addEventListener('DOMContentLoaded', function () { initMore(); });
  }

  // テーマエディタでのセクション再読込に対応
  document.addEventListener('shopify:section:load', function (e) {
    initMore(e.target);
  });

  // アコーディオン（設計思想）：パネル末尾の閉じる矢印クリックで details を閉じる
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.daski-aphi__close');
    if (!btn) return;
    var details = btn.closest('details');
    if (details) details.open = false;
  });
})();
